import { render, staticRenderFns } from "./costAdList.vue?vue&type=template&id=93a6530c&scoped=true"
import script from "./costAdList.vue?vue&type=script&lang=js"
export * from "./costAdList.vue?vue&type=script&lang=js"
import style0 from "./costAdList.vue?vue&type=style&index=0&id=93a6530c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a6530c",
  null
  
)

export default component.exports